import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import cookie from '../../static/js/cookie.js'

Vue.use(Router)

const loginForm = () => import('../components/login/loginForm');
const displayView = () => import('../components/threeD/threeDisplay');
const home = () => import('../components/patientManager/home');
const caseDetail = () => import('../components/caseDetail/caseDetailFrame');
const createCase = () => import('../components/patientManager/createCase'); //例子
const logout = () => import('../components/login/logout');
const about = () => import('../components/userCenter/about');
const college = () => import('../components/userCenter/college');
const schemeReportInfo = () => import('../components/threeD/subViews/schemeReportInfo');
const imageViewWidget = () => import('../components/caseDetail/subViews/imageViewWidget');
const alignerCreateWidget = () => import('../components/patientManager/subViews/alignerCreateWidget');
const submitForProductionWidget = () => import('../components/patientManager/subViews/submitForProductionWidget');
const confirmForProduction = () => import('../components/patientManager/subViews/confirmForProduction');
const verifyPassword = () => import('../components/previewScheme/verifyPassword');
const schemePreviewPage = () => import('../components/previewScheme/schemePreviewPage')
const schemeSubmitHistoryWidget = () => import('../components/patientManager/subViews/schemeSubmitHistoryWidget')
const createCaseOption = () => import('../components/common/createCaseOption')

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      component: loginForm,
      name: 'login',
      meta: {
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/logout',
      component: logout,
      name: 'logout',
      meta: {
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/home',
      component: home,
      name: 'home',
      meta: {
        requireAuth: true,
        bannerEnable: true,
        commonNavEnable: true,
      }
    },
    {
      path: '/displayView',
      component: displayView,
      name: 'displayView',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/caseDetail',
      component: caseDetail,
      name: 'caseDetail',
      meta: {
        requireAuth: true, // false - 跳过身份
        bannerEnable: true,
        commonNavEnable: true,
      }
    },
    {
      path: '/createCase/:useLanguage?',
      component: createCase,
      name: 'createCase',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/about',
      component: about,
      name: 'about',
      meta: {
        requireAuth: true,
        bannerEnable: true,
        commonNavEnable: true,
      }
    },
    {
      path: '/college',
      component: college,
      name: 'college',
      meta: {
        requireAuth: true,
        bannerEnable: true,
        commonNavEnable: true,
      }
    },
    {
      path: '/schemeReportInfo',
      component: schemeReportInfo,
      name: 'schemeReportInfo',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/imageViewWidget',
      component: imageViewWidget,
      name: 'imageViewWidget',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/alignerCreateWidget',
      component: alignerCreateWidget,
      name: 'alignerCreateWidget',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/submitForProductionWidget',
      component: submitForProductionWidget,
      name: 'submitForProductionWidget',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/confirmForProduction',
      component: confirmForProduction,
      name: 'confirmForProduction',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/verifyPassword/:param',
      component: verifyPassword,
      name: 'verifyPassword',
      meta: {
        requireAuth: false,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/schemePreviewPage/:param',
      component: schemePreviewPage,
      name: 'schemePreviewPage',
      meta: {
        requireAuth: false,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/schemeSubmitHistoryWidget',
      component: schemeSubmitHistoryWidget,
      name: 'schemeSubmitHistoryWidget',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },
    {
      path: '/createCaseOption',
      component: createCaseOption,
      name: 'createCaseOption',
      meta: {
        requireAuth: true,
        bannerEnable: false,
        commonNavEnable: false,
      }
    },

  ]
})

let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
//全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  // cookie.set('language', "zh");
  let currentBaseUrl = axios.defaults.baseURL.replace('/case', '');
  if (to.meta['requireAuth']) {
    //判断该路由是否需要登录权限
    if (cookie.get('session') || sessionStorage.getItem('session') || localStorage.getItem('session')) {
      let loginParam = {
        token: cookie.get('session') ? cookie.get('session') : sessionStorage.getItem('session')
      }
      axios({
        method: 'POST',
        url: currentBaseUrl + '/login/verifyToken/' + loginParam.token,
      }).then((response) => {
        // console.log(response)
        if (response['code'] === 0) {
          if (response.data.token) {
            sessionStorage.setItem('session', response.data.token);
            if (sessionStorage.getItem("viewButton") == null || sessionStorage.getItem("viewButton") === "") {
              axios({
                method: 'GET',
                url: currentBaseUrl + '/auth/sysUser/view'
              }).then((res) => {
                if (res['code'] === 0) {
                  sessionStorage.setItem('viewButton', JSON.stringify(res.data));
                }
              });
            }
            if (sessionStorage.getItem("userInfo") == null || sessionStorage.getItem("userInfo") === "") {
              axios({
                method: 'GET',
                url: currentBaseUrl + '/auth/sysUser'
              }).then((res) => {
                if (res['code'] === 0) {
                  sessionStorage.setItem('userInfo', JSON.stringify(res.data));
                  sessionStorage.setItem('positionId', res.data.position);
                }
              });
            }

          }
          next();
        } else {
          sessionStorage.removeItem('session');
          if (cookie.get('session') || localStorage.getItem('session')) {
            cookie.remove('session');
            localStorage.removeItem('session');
          }
          next({
            path: '/login',
          })
        }
      }).catch((error) => {
        console.log(error);
        next({
          path: '/login',
        })
      })
    } else {
      next({
        path: '/login',
      })
    }
  }
  else if (to.path === '/logout') {
    next();
  }
  else {
    next();
  }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js